/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AmendSentToSignerApp_amendSentToSignerApp_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string, readonly status: _Types.CreditApplicationStatus | null };

export type AmendSentToSignerApp_Mutation = { readonly __typename: 'Mutation', readonly amendSentToSignerApp: AmendSentToSignerApp_amendSentToSignerApp_CreditApplication };


export type AmendSentToSignerAppVariables = _Types.Exact<{
  salesforceCreditId: _Types.Scalars['ID']['input'];
}>;


export type AmendSentToSignerApp = AmendSentToSignerApp_Mutation;


export const AmendSentToSignerAppDocument = gql`
    mutation AmendSentToSignerApp($salesforceCreditId: ID!) {
  amendSentToSignerApp(salesforceCreditId: $salesforceCreditId) {
    salesforceCreditId
    status
  }
}
    `;
export type AmendSentToSignerAppMutationFn = Apollo.MutationFunction<AmendSentToSignerApp, AmendSentToSignerAppVariables>;

/**
 * __useAmendSentToSignerApp__
 *
 * To run a mutation, you first call `useAmendSentToSignerApp` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAmendSentToSignerApp` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [amendSentToSignerApp, { data, loading, error }] = useAmendSentToSignerApp({
 *   variables: {
 *      salesforceCreditId: // value for 'salesforceCreditId'
 *   },
 * });
 */
export function useAmendSentToSignerApp(baseOptions?: Apollo.MutationHookOptions<AmendSentToSignerApp, AmendSentToSignerAppVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AmendSentToSignerApp, AmendSentToSignerAppVariables>(AmendSentToSignerAppDocument, options);
      }
export type AmendSentToSignerAppHookResult = ReturnType<typeof useAmendSentToSignerApp>;
export type AmendSentToSignerAppMutationResult = Apollo.MutationResult<AmendSentToSignerApp>;
export type AmendSentToSignerAppMutationOptions = Apollo.BaseMutationOptions<AmendSentToSignerApp, AmendSentToSignerAppVariables>;